import { apiRequest } from "@/features/api/apiClient";
import type { AccessSummary } from "@/features/access/accessTypes";

type AccessSummaryResponse = {
  access: AccessSummary;
};

export function getAccessSummary(
  token: string | null,
): Promise<AccessSummaryResponse> {
  return apiRequest<AccessSummaryResponse>("/api/me/access", { token });
}

export type RedeemAccessCodeResponse = {
  ok: true;
  access: AccessSummary;
  tierGranted: string;
  message: string;
};

export function redeemAccessCode(
  token: string | null,
  code: string,
): Promise<RedeemAccessCodeResponse> {
  return apiRequest<RedeemAccessCodeResponse>("/api/promo-codes/redeem", {
    method: "POST",
    token,
    body: { code },
  });
}
